{
  "unsubscribe_title": "Se désabonner des e-mails",
  "unsubscribe_message": "Désolé de vous voir partir.",
  "unsubscribe": "Se désabonner",
  "cancel": "Annuler",
  "passwordResetSuccess": "Votre mot de passe a été modifié avec succès.",
  "passwordResetError": "Malheureusement, il y a eu un problème",
  "passwordResetExpired": "Ce lien est invalide ou expiré. Merci de demander un nouvel e-mail de réinitialisation du mot de passe.",
  "passwordResetTitle": "Définir un nouveau mot de passe",
  "new_password": "Nouveau mot de passe",
  "confirm_password": "Confirmer le nouveau mot de passe",
  "save": "Enregistrer",
  "error": "Malheureusement, il y a eu un problème",
  "unsubscribeSuccess": "L'action a été réussie",
  "emailChangeLoading": "Changement d'e-mail en cours...",
  "emailChangeSuccess": "L'e-mail a été changé avec succès",
  "emailChangeError": "Malheureusement, il y a eu un problème lors du changement d'e-mail",
  "home": {
    "tagline": "Plus d'1 million de propriétaires de chiens s'entraînent avec Hundeo",
    "subline": "Recommandée par de vrais éducateurs canins",
    "appStorePrefix": "Télécharger sur",
    "playStorePrefix": "Disponible sur",
    "qrHint": "Ouvrir l'app sur ton téléphone",
    "qrCaption": "Scanne le code avec ton appareil photo",
    "socialProof": "5 000+ avis 5 étoiles",
    "imprint": "Mentions légales",
    "privacy": "Confidentialité",
    "language": "Langue",
    "openWebsite": "Voir le site",
    "openInApp": "Ouvrir dans l'app Hundeo",
    "openInAppHint": "Tu seras redirigé vers ton app",
    "openInAppButton": "Ouvrir",
    "promoRedirectTitle": "Ouverture de ton offre …",
    "promoRedirectButton": "Voir ton offre"
  }
}
